import React, {useState} from 'react';

import {BenchlingSelection} from 'notebook/mediocre/selection/SelectionStore';
import {TableIndex} from 'notebook/tables/constants/TableSelectionConstants';

import {Editor} from '../EditorTypes';
import {MetadataForRestore} from '../selection/block/MultiSelectListUtil';
import CtrlFInputOverlay from './CtrlFInputOverlay';
import {MediocreSearchState} from './useCtrlF';
import useIsCtrlFOpen from './useIsCtrlFOpen';

export interface CtrlFInputProps<TEditor extends Editor<TRoot, TItem>, TRoot, TItem> {
  docRoot: TRoot;
  editor: TEditor;
  searchableItems: Array<TItem>;
  focusedItem?: TItem;
  searchState: MediocreSearchState | undefined;
  setSearchState: (searchState: MediocreSearchState) => void;
  requestSelection: (selection: {selection: BenchlingSelection} | MetadataForRestore<TableIndex>) => void;
}

export default function CtrlFInput<TEditor extends Editor<TRoot, TItem>, TRoot, TItem>(
  props: CtrlFInputProps<TEditor, TRoot, TItem>
): JSX.Element | null {
  const [query, setQuery] = useState('');
  const {isOpen, setOpen} = useIsCtrlFOpen({setQuery});
  if (!isOpen) {
    return null;
  }
  return <CtrlFInputOverlay {...props} isOpen={isOpen} setOpen={setOpen} query={query} setQuery={setQuery} />;
}
